import React, { useState, useEffect } from 'react';
import { FaSyncAlt, FaTimes } from 'react-icons/fa';
import './MediaViewerModal.css';

const MediaViewerModal = ({ isOpen, onClose, mediaUrl, typeHint = '' }) => {
    const [rotation, setRotation] = useState(0);

    useEffect(() => {
        // Reset rotation when modal opens/closes or URL changes
        setRotation(0);
    }, [isOpen, mediaUrl]);

    if (!isOpen || !mediaUrl) return null;

    const handleRotate = (e) => {
        e.stopPropagation();
        setRotation((prev) => (prev + 90) % 360);
    };

    // Simple heuristic to determine media type
    const getMediaType = (url, hint) => {
        if (!url) return 'unknown';
        const lowerUrl = url.toLowerCase();
        const lowerHint = (typeof hint === 'string' ? hint : '').toLowerCase();
        
        if (lowerUrl.includes('.pdf') || lowerHint.includes('pdf')) return 'pdf';
        if (lowerUrl.includes('.mp4') || lowerUrl.includes('.webm') || lowerUrl.includes('.ogg') || lowerUrl.includes('.mov') || lowerHint.includes('video')) return 'video';
        if (lowerUrl.includes('.mp3') || lowerUrl.includes('.wav') || lowerUrl.includes('.m4a') || lowerUrl.includes('.aac') || lowerUrl.includes('.amr') || lowerHint.includes('audio')) return 'audio';
        
        // Assume image by default for other extensions or signed S3 URLs that lack extensions
        return 'image';
    };

    const mediaType = getMediaType(mediaUrl, typeHint);

    return (
        <div className="media-viewer-viewport" onClick={onClose}>
            <div className="media-viewer-modal" onClick={(e) => e.stopPropagation()}>
                
                <div className="media-viewer-header">
                    <div className="media-viewer-controls">
                        {mediaType === 'image' && (
                            <button className="media-btn" onClick={handleRotate} title="Rotate Image">
                                <FaSyncAlt size={18} />
                            </button>
                        )}
                        <button className="media-btn" onClick={onClose} title="Close">
                            <FaTimes size={20} />
                        </button>
                    </div>
                </div>

                <div className="media-content-container">
                    {mediaType === 'image' && (
                        <img 
                            src={mediaUrl} 
                            alt="Document Preview" 
                            className="media-image" 
                            style={{ transform: `rotate(${rotation}deg)` }} 
                        />
                    )}
                    {mediaType === 'video' && (
                        <video 
                            src={mediaUrl} 
                            controls 
                            autoPlay 
                            className="media-video"
                        />
                    )}
                    {mediaType === 'audio' && (
                        <audio 
                            src={mediaUrl} 
                            controls 
                            autoPlay 
                            className="media-audio"
                            style={{ width: '300px', height: '50px' }}
                        />
                    )}
                    {mediaType === 'pdf' && (
                        <iframe 
                            src={mediaUrl} 
                            title="PDF Preview"
                            className="media-iframe"
                        />
                    )}
                </div>

            </div>
        </div>
    );
};

export default MediaViewerModal;
